import { Roles } from "../constants/roles";
import { FormBase } from "../util/form-base-form";

export class AboutUsTabsForm extends FormBase {
    private readonly root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public isInitialized(): boolean {
        return this.root.dataset.aboutUsTabsInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.aboutUsTabsInit = "1";
    }

    public getTabs(): HTMLElement[] {
        return this.queryElements(this.root, `[data-role="${Roles.ABOUT_US_TAB}"]`, HTMLElement);
    }

    public getPanels(): HTMLElement[] {
        return this.queryElements(this.root, `[data-role="${Roles.ABOUT_US_PANEL}"]`, HTMLElement);
    }

    public getTabsBar(): HTMLElement {
        return this.queryElement(this.root, `[data-role="${Roles.ABOUT_US_TABS}"]`, HTMLElement) ?? this.root;
    }

    public getNavbar(): HTMLElement | null {
        return this.queryElement(document, ".navbar-top", HTMLElement);
    }
}
